import { detectUserRegion } from '@common/core/utils/detectUserRegion'

import { getUserRegionalData } from '../regional-user'
import type { InitializeRegionalInput, InitializeRegionalResult } from '../types'

import { addUserRegionalDataAndIdentity } from './add-user-regional-data-and-identity'

export async function initializeUserRegionalData(input: InitializeRegionalInput): Promise<InitializeRegionalResult> {
  try {
    const region = detectUserRegion()
    const regionalData = await getUserRegionalData()
    const regionalIdentity = { userRegionalIdentityId: '', region: '', userUid: '' }

    if (regionalData) {
      return { regionalData, regionalIdentity }
    }

    return addUserRegionalDataAndIdentity(input, region, regionalData)
  } catch (error) {
    console.error('Failed to initialize user regional data:', error)
    return { regionalData: null, regionalIdentity: null }
  }
}
